function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.6313 23.6387H22.3168V6.10358C22.3168 5.39499 21.7247 4.82812 20.9847 4.82812C9.41967 4.82812 0.00585938 13.8414 0.00585938 24.9142C0.00585938 35.9871 9.41967 45.0003 20.9847 45.0003C32.5496 45.0003 41.9635 35.9871 41.9635 24.9142C41.9635 24.2151 41.3615 23.6387 40.6313 23.6387ZM20.9847 42.4494C10.89 42.4494 2.67015 34.5793 2.67015 24.9142C2.67015 15.6742 10.1696 8.07818 19.6525 7.42628V24.9142C19.6525 25.6228 20.2446 26.1897 20.9847 26.1897H39.2498C38.569 35.269 30.6353 42.4494 20.9847 42.4494Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9847 42.4494C10.89 42.4494 2.67015 34.5793 2.67015 24.9142C2.67015 15.6742 10.1696 8.07818 19.6525 7.42628V24.9142C19.6525 25.6228 20.2446 26.1897 20.9847 26.1897H39.2498C38.569 35.269 30.6353 42.4494 20.9847 42.4494Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M46.9945 20.0199C46.9748 15.1449 45.1098 10.4493 41.7449 6.79299C37.7583 2.47533 32.0351 0 26.0157 0C25.2757 0 24.6836 0.56687 24.6836 1.27546V20.0861C24.6836 20.7947 25.2757 21.3615 26.0157 21.3615H45.6624C46.4025 21.3615 46.9945 20.7947 46.9945 20.0861C46.9945 20.0672 46.9945 20.0483 46.9945 20.0199ZM27.3479 18.8201V2.6076C32.1041 2.93827 36.5643 5.04514 39.7418 8.4936C42.406 11.3752 43.9849 15.0031 44.2809 18.8201H27.3479Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3479 18.8201V2.6076C32.1041 2.93827 36.5643 5.04514 39.7418 8.4936C42.406 11.3752 43.9849 15.0031 44.2809 18.8201H27.3479Z",
  fill: "currentColor"
});

function SvgSectorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    color: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorIcon);
export default __webpack_public_path__ + "static/media/sectorIcon.dd05bb69.svg";
export { ForwardRef as ReactComponent };